import { toNumberLookup } from "@/utils/groupBy"
import { timeFromString } from "@/utils/time"
import { uuidv4 } from "@/utils/uuid"
import { AloAccompagnement } from "./AloAccompagnement"
import { AloAllergene } from "./AloAllergene"
import { AloArbo } from "./AloArbo"
import { AloBase, getDefaultAloBase } from "./AloBase"
import { IItemPanier, ItemPanier } from "./ItemPanier"


export interface IPanier  {  
    uuid?:string  
    items:Array<IItemPanier>        
    heureLivraison:string
    nbCouverts:number   
    timeDebut:number
    timeFin:number
    tempsPreparation:number
    contacts:Array<string>
    allContacts:boolean    
    commentaire:string
}

export class AloPanier  {   
    public items:Array<ItemPanier>     
    public uuid:string
    public heureLivraison:string
    public nbCouverts:number    
    public timeDebut:number
    public timeFin:number
    public tempsPreparation:number
    public contacts:Array<string>
    public allContacts:boolean
    public commentaire:string

    constructor({items,heureLivraison,nbCouverts,timeDebut,timeFin,tempsPreparation,contacts,allContacts,commentaire,uuid}:IPanier = {} as IPanier) {    
        this.uuid = uuid ?? uuidv4()
        this.items = items?.map(it => new ItemPanier(it)) ?? []   
        this.heureLivraison = heureLivraison || ""
        this.nbCouverts = nbCouverts || 1        
        this.timeDebut = timeDebut ?? 0   
        this.timeFin = timeFin || 86340000
        this.tempsPreparation = tempsPreparation ?? 30
        this.contacts = contacts ?? []
        this.allContacts = allContacts ?? true
        this.commentaire = commentaire || ""
    }              
    
    public get nbItems() {   
        return this.items.reduce((total,item)=>total+item.qty,0)
    }

    get prixTotalAvecOptions() {
        return this.items.reduce((total,item)=>total+item.prixTotalAvecOptions,0)
    }

    get tvas():Array<{pourcentage:number,montant:number}> {        
        const dicTva = this.items.reduce((tvas,item) => {            
            tvas[item.plat.tva!] = (tvas[item.plat.tva!] ?? 0) + ( (item.plat.tva!/100.0) * item.prixTotalAvecOptions / (100.0+(item.plat.tva!/100.0)) )
            return tvas
        },{}  as {[tva:number]:number})                  
        return Object.keys(dicTva).map(k => {return {pourcentage:Number.parseInt(k),montant:dicTva[Number.parseFloat(k)]}})
    }

    canAddFromArbo(arbo:AloArbo) {
        const arboDebut = timeFromString(arbo.heureDebut!)
        const arboFin = timeFromString(arbo.heureFin!)
        return arboDebut < this.timeFin && arboFin > this.timeDebut
    }

    updateTime(dicArbo:{[id:number]:AloArbo}) {
        let maxDebut = 0
        let minFin = 86340000
        let minTempsPreparation = 30
        this.items.forEach(item => {
            if(item.arboId) {
                const arboDebut = timeFromString(dicArbo[item.arboId].heureDebut!)
                const arboFin = timeFromString(dicArbo[item.arboId].heureFin!) 
                if(maxDebut < arboDebut)  maxDebut = arboDebut            
                if(minFin > arboFin)  minFin = arboFin                                           
                if(minTempsPreparation < (dicArbo[item.arboId].tempsPreparation ?? 0)) minTempsPreparation = dicArbo[item.arboId].tempsPreparation!
            }
            if(item.plat.template == 'plat-produit-oeuf'){
                const oeufDebut = timeFromString("06:30")
                const oeufFin = timeFromString("11:00") 
                if(maxDebut < oeufDebut)  maxDebut = oeufDebut            
                if(minFin > oeufFin)  minFin = oeufFin            
            }
        })
        this.timeFin = minFin
        this.timeDebut = maxDebut
        this.tempsPreparation = minTempsPreparation
    }

}
